import React from 'react';
import { Progress } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWarehouse } from '@fortawesome/free-solid-svg-icons';
import {
    createDataSource,
    createGridOptions,
    DataGrid,
    indexCellRenderer,
    LinkCellRenderer,
    TextFilterDefaults,
} from '../common/dataGrid/DataGrid';
import DataGridSelectFilter from '../common/dataGrid/DataGridSelectFilter';
import CommonContext, { ApiRoutes, AppNavPaths } from '../Common';
import { PageHeading, PageWrap } from '../common/forms/FormElements';
import DataGridSelectFloatingFilter from '../common/dataGrid/DataGridSelectFloatingFilter';
import DataGridToolbar from '../common/dataGrid/DataGridToolbar';

class EquipmentTagIndex extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);
        const yesNo = [
            { label: 'Yes', value: 'true' },
            { label: 'No', value: 'false' },
        ];
        this.state = {
            loading: true,
            rowData: [],
            yesNo,
        };
        this.onAddEquipmentTag = this.onAddEquipmentTag.bind(this);
    }

    componentDidMount() {
        return this.populateState();
    }

    populateState = () => {
        const context = this;

        const gridOptions = createGridOptions(this);

        gridOptions.components = {
            selectFilter: DataGridSelectFilter,
            selectFloatingFilter: DataGridSelectFloatingFilter,
            nameRenderer: LinkCellRenderer,
        };

        const yesNoFilterParams = {
            suppressFilterButton: true,
            options: this.state.yesNo,
            optionsLabel: 'label',
            optionsValue: 'value',
            initialFilterValue: '',
        };

        gridOptions.columnDefs = [
            {
                flex: 0,
                width: 80,
                headerName: '',
                valueGetter: 'node.id',
                sortable: false,
                cellRenderer: indexCellRenderer,
            },
            {
                colId: 'Tag',
                sortable: false,
                headerName: 'Tag',
                field: 'tag',
                cellRenderer: 'nameRenderer',
                cellRendererParams: {
                    to: (id) => `${AppNavPaths.EquipmentTag}/${id}`,
                    nameField: 'tag',
                    idField: 'id',
                    title: 'View this Tag',
                },
                filter: 'agTextColumnFilter',
                filterParams: TextFilterDefaults,
                floatingFilter: true,
                floatingFilterComponentParams: {
                    suppressFilterButton: true,
                },
            },
            {
                colId: 'Description',
                sortable: false,
                headerName: 'Description',
                field: 'description',
                filter: 'agTextColumnFilter',
                filterParams: TextFilterDefaults,
                floatingFilter: true,
                floatingFilterComponentParams: {
                    suppressFilterButton: true,
                },
            },
            {
                colId: 'IsActive',
                headerName: 'Active',
                field: 'isActive',
                sortable: true,
                flex: 1.5,
                tooltipField: 'status',
                filter: 'selectFilter',
                floatingFilter: true,
                filterParams: yesNoFilterParams,
                floatingFilterComponent: 'selectFloatingFilter',
                floatingFilterComponentParams: yesNoFilterParams,
            },
        ];

        gridOptions.postProcessData = (data) => {
            context.setState({
                rowData: data.rows,
            });

            return { ...data };
        };

        gridOptions.onGridReady = (params) => {
            params.api.setDatasource(context.state.dataSource);
            context.setState({ gridApi: params.api });
        };

        const ds = createDataSource(
            ApiRoutes.equipmentTags.search(),
            gridOptions,
        );

        this.setState({
            loading: false,
            gridOptions,
            dataSource: ds,
        });
    };

    onAddEquipmentTag = () => {
        this.context.history.push(`${AppNavPaths.EquipmentTagNew}`);
    };

    render() {
        if (this.state.loading) return <Progress />;
        const { rowData, gridOptions } = this.state;
        return (
            <PageWrap>
                <PageHeading>
                    <FontAwesomeIcon
                        icon={faWarehouse}
                        className="mr-2 text-muted"
                    />
                    <span>Equipment Tags</span>
                </PageHeading>
                <DataGridToolbar
                    entity="equipment_tag"
                    gridApi={this.state.gridApi}
                    dataSource={this.state.dataSource}
                    onAdd={this.onAddEquipmentTag}
                    addLabel="Add Equipment Tag"
                    hideExcelButton
                />
                <DataGrid
                    domLayout="normal"
                    rowData={rowData}
                    gridOptions={gridOptions}
                    gridStatus={this.state.gridStatus}
                />
            </PageWrap>
        );
    }
}
export default EquipmentTagIndex;
